import React, { useContext } from "react";

import "./style.scss";
// import data from "./data";
import { LanguageContext, text } from "../../container/language";
import { padding } from "polished";

const File = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);
  const { title, description, file, file_en } = data;

  const currentFile =
    userLanguage === "en" && file_en && file_en.url ? file_en : file;
  const { url, size, ext } = currentFile;

  return (
    <div className="file-list__item">
      <a href={url} className="file" target="_blank">
        <div className="file__type">
          <i className={`i-${formatExtension(ext)}`}></i>
        </div>
        <div className="file__text">
          <strong className="file__text-name">
            <font>
              <font>{text(title, userLanguage)}</font>
            </font>
          </strong>
          {description && (
            <span
              className="download-list__text"
              style={{
                color: "#445267",
                paddingTop: "5px",
                paddingBottom: "5px",
              }}
            >
              {text(description, userLanguage)}
            </span>
          )}
          <span className="file__text-info">
            <font>
              <font>{formatExtension(ext)}</font>
            </font>
          </span>
          <span className="file__text-info">
            <font>
              <font>{size} KB</font>
            </font>
          </span>
        </div>
        <div className="file__action">
          <i className="i-file-search-alt"></i>
        </div>
      </a>
    </div>
  );
};

const formatExtension = (ext) => {
  return ext.substring(1);
};

export default File;
